import React, { useContext, useEffect } from 'react'
import { IntlProvider } from 'react-intl'

import { Trad } from '../common/Trad'
import { useListRequest } from '../../hooks/request'
import { unitList } from '../../requests/unitList'
import { messageList } from '../../requests/messageList'
import { arrayToSelectValue } from '../../utils/convertArray'
import { UnitsContext } from '../../data/UnitsContext'
import { Loader } from '../icons/Loader'
import { CenterStuff } from '../common/CenterStuff'

export const DataWaiter = ({ children }) => {
  const { units, setUnits } = useContext(UnitsContext)

  // user got a token, we can collect data from api
  const getMessageListRequest = useListRequest({
    start: true,
    request: messageList,
  })
  const getUnitRequest = useListRequest({
    start: true,
    request: unitList,
  })

  useEffect(() => {
    // if no data store before
    if (!units) {
      const unitsData = arrayToSelectValue(getUnitRequest.state.data, 'name')
      setUnits(unitsData)
    }
  }, [units, getUnitRequest.state.data])

  // waiting for data download
  if (getUnitRequest.state.loading
    || !getUnitRequest.state.data
    || getMessageListRequest.state.loading
    || !getMessageListRequest.state.data) { // display loader
    return (
      <CenterStuff>
        <Loader height={100} />
      </CenterStuff>
    )
  }

  // if got an error from the api
  if (getUnitRequest.state.error || getMessageListRequest.state.error) {
    return <Trad id="errorRetry" />
  }
  // if all the data has been downloaded correctly
  if (units && getMessageListRequest.state.data) {
    return (
      <IntlProvider locale="fr" messages={getMessageListRequest.state.data}>
        {children}
      </IntlProvider>
    )
  }

  return 'loading'
}
